/**
 * description 图片素材详情页
 * created by he.zhikai
 * created on 2017-12-20
 */
'use strict';
angular.module('resourceCenterPictureDetailModule', [])
    .controller('resourceCenterPictrueDetailCtrl', ['$scope', '$state', '$timeout', '$stateParams', 'trsHttpService', 'modalDialog', 'trsPrintService', 'resourceCenterService', 'localStorageService',
        function($scope, $state, $timeout, $stateParams, trsHttpService, modalDialog, trsPrintService, resourceCenterService, localStorageService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.params = {
                    serviceid: 'tpg',
                    modelid: 'bmtDetail',
                    typeid: 'zyzx',
                    docId: $stateParams.guid
                };
                $scope.status = {
                    listOpen: 'processView', // 默认选中的属性信息
                    attrDropdown: {
                        groupProcess: true, // 集团取签流程
                        groupEntityInfo: true // 稿件信息
                    },
                    atlas: false // 图集展开
                };
                $scope.data = {
                    keywordsArray: [], // 关键词数组
                    tenantInfo: '', // 租户信息
                    groupProcess: { // 集团取签流程
                        medias: [], // 媒体列表
                        operators: [{ // 操作人
                            name: '取稿人',
                            value: 'takeDraft'
                        }, {
                            name: '签发人',
                            value: 'issue'
                        }, {
                            name: '见报人',
                            value: 'appearNews'
                        }, {
                            name: '撤稿人',
                            value: 'withdraw'
                        }],
                        process: [], // 取签流程
                        selectedMedia: '' // 选中的产品
                    }
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                requestData();
                initQqjccInfos();
            }

            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.detailInfos = data.content[0];
                });
            }

            /**
             * [initQqjccInfos description] 初始化取签见撤重信息
             * @return {[type]} [description]
             */
            function initQqjccInfos() {
                getQqjccChannel();
                getQqjccInfo();
            }

            /**
             * [getQqjccChannel description] 获取取签见撤重媒体
             * @return {[type]} [description]
             */
            function getQqjccChannel() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'queryOperMediasList',
                    guid: $stateParams.guid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.groupProcess.medias = [{
                        MEDIANAME: '全部',
                        MEDIATYPE: '',
                        MEDIAID: ''
                    }].concat(data);
                    $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
                });
            }

            /**
             * [getQqjccInfo description] 获取取签见撤重信息
             * @return {[type]} [description]
             */
            function getQqjccInfo() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'queryOperFlagList',
                    guid: $stateParams.guid,
                    mediaid: $scope.data.groupProcess.selectedMedia.MEDIAID,
                    mediatype: $scope.data.groupProcess.selectedMedia.MEDIATYPE
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.groupProcess.process = data.OPERS;
                    if ($scope.data.groupProcess.process.length > 1) {
                        $('.resource_detail .groupProcess_process').css('height', ($scope.data.groupProcess.process.length - 1) * 120 + 'px');
                    } else {
                        $('.resource_detail .groupProcess_process').css('height', '0px');
                    }
                });
            }

            /**
             * [selectQqjccChannel description] 选择取签见撤重媒体
             * @param  {[type]} media [description] 当前媒体
             * @return {[type]}       [description]
             */
            $scope.selectQqjccChannel = function(media) {
                $scope.data.groupProcess.selectedMedia = media;
                getQqjccInfo();
            };

            /**
             * [pageTurning description] 翻页 上一篇/下一篇
             * @param {int} direction [description]
             * @return {[type]} [description]
             */
            $scope.pageTurning = function(direction) {
                var pageTurningData = JSON.parse(localStorageService.get('resourceDetail'));
                var toPageData;
                for (var i = 0; i < pageTurningData.length; i++) {
                    if (pageTurningData[i].DOC_ID === $stateParams.guid) {
                        toPageData = pageTurningData[i + direction];
                        break;
                    }
                }
                if (!toPageData) {
                    var directionTxt = direction === 1 ? '下' : '上';
                    modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                    return;
                }
                $state.go($state.current.name, {
                    guid: toPageData.DOC_ID,
                    nodeid: $stateParams.nodeid
                }, {
                    reload: true
                });
            };

            /**
             * [contentResize description] 设置左右侧高度一样
             * @return {[type]} [description]
             */
            $scope.contentResize = function() {
                $timeout(function() {
                    var $father = $('.resource_detail');
                    var $left = $father.find('.resource_detail_article');
                    var $right = $father.find('.resource_detail_relatedInfo');
                    var leftHeight = $left.height();
                    $right.height(leftHeight);
                    $left.resize(function(event) {
                        var leftHeight = $left.height();
                        $right.height(leftHeight);
                    });
                });
            };

            /**
             * [openOriginalPic description] 查看完整图片
             * @param  {[type]} url [description] 图片地址
             * @return {[type]}     [description]
             */
            $scope.openOriginalPic = function(url) {
                window.open(url);
            };

            /* 稿件操作开始*/
            /**
             * [creationAxis description]个人素材
             * @return {[type]} [description]
             */
            $scope.creationAxis = function() {
                var params = {
                    channelName: 'tpg',
                    nodeId: $stateParams.nodeid,
                    guid: $stateParams.guid,
                    PICIDS: ''
                };
                $scope.loadingPromise = resourceCenterService.setBigDataCreation(params).then(function(data) {
                    modalDialog.alertType('添加成功', '', 'success', false);
                });
            };

            /**
             * [collect description] 收藏
             * @return {[type]} [description]
             */
            $scope.collect = function() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'collectPics',
                    guid: $stateParams.guid,
                    indexName: 'mlf_history_photo_20161021',
                    nodeId: $stateParams.nodeid,
                    channelName: 'tpg',
                    typeName: 'tpg'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false);
                });
            };

            /**
             * [printBtn description] 打印
             * @return {[type]} [description]
             */
            $scope.printBtn = function() {
                var params = {
                    serviceid: 'tpg',
                    modelid: 'bmtDetail',
                    guid: $stateParams.guid,
                    typeid: 'zyzx'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                    trsPrintService.trsPrintHistoryPictures(data);
                });
            };

            /* 稿件操作结束*/
        }
    ]);
